import { createFileRoute } from '@tanstack/react-router'

import { ServiceHistoryDetailZero } from '../../../components/service-history/components/ServiceHistoryDetailZero'

export const Route = createFileRoute('/app/service-history/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <ServiceHistoryDetailZero />
}
